<template>
  <div v-if="hasPerms(perms)" class="tcol">
    <slot></slot>
  </div>
</template>

<script>
  import { hasPermission } from './index.js'
  export default{
    name: 'PreModular',
    props:{
      perms: {  // 按钮权限标识，外部使用者传入
        type: String,
        default: null
      },
    },
    methods:{
      hasPerms: function (perms) {
        return hasPermission(perms) & !this.disabled
      }
    }



  }
</script>

<style>
  .tcol{
    flex: 1;
    border: 2px solid #f4f4f4;
    border-left: 0;
    height: 380px;
    overflow: hidden;
    padding: 0 10px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/views/permission/preModular.vue